<div class="page">
  <app-relatorio-header
    [anos]="anosDisponiveis()"
    [anoSelecionado]="anoSelecionado()"
    [viewMode]="viewMode()"
    [metaToggle]="metaToggle()"
    (anoChange)="onAnoChange($event)"
    (viewModeChange)="onViewModeChange($event)"
    (metaToggleChange)="onMetaToggleChange($event)"
  ></app-relatorio-header>

  <div class="content">
    <app-meses-lista
      [meses]="anoData().meses"
      [mesSelecionado]="mesSelecionado()"
      (mesSelect)="onMesSelect($event)"
    ></app-meses-lista>

    <div class="right-panel">
      @if (viewMode() === 'GRAFICOS') {
        @if (!mesSelecionado()) {
          <app-visao-anual
            [ano]="anoSelecionado()"
            [meses]="anoData().meses"
            [totalAnual]="totalAnual()"
            [loading]="carregandoAno()"
            [metaToggle]="metaToggle()"
            (toggleMeta)="onMetaToggleChange($event)"
          ></app-visao-anual>
        } @else {
          <app-visao-mensal
            [ano]="anoSelecionado()"
            [mes]="mesData()"
            [loading]="carregandoMes()"
            [metaToggle]="metaToggle()"
            (toggleMeta)="onMetaToggleChange($event)"
          ></app-visao-mensal>
        }
      } @else {
        <app-visao-ranking
          [ano]="anoSelecionado()"
          [mes]="mesData()"
          [loading]="carregandoRanking()"
          [mesSelecionado]="mesSelecionado()"
          [meses]="anoData().meses"
        ></app-visao-ranking>
      }
    </div>
  </div>
</div>
